import { render, staticRenderFns } from "./mental-health-why-joined-card.vue?vue&type=template&id=cc95d03e&scoped=true&"
import script from "./mental-health-why-joined-card.vue?vue&type=script&lang=js&"
export * from "./mental-health-why-joined-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc95d03e",
  null
  
)

export default component.exports